// Copyright Epic Games, Inc. All Rights Reserved.

export default {
  messages: {
    "error.errorCode": "エラー コード:",
    "error.search": "詳細については、知識ベースを検索してください。",
    dismiss: "閉じる",
    "installation.title": "",
    "cancelation.button": "キャンセル",
  },
  errorCodes: {
    "EOS-UI-NF": {
      title: "初期化に失敗しました",
      description:
        "ページをレンダリングできませんでした。サポートに連絡してください。",
    },
    "EOS-UI-UE": {
      title: "問題が生じました。",
      description: "問題が生じました。サポートに連絡してください。",
    },
    "EOS-IN-BC": {
      title: "インストールに失敗しました",
      description:
        "インストールの進行状況を表示できませんでした。サポートに連絡してください。",
    },
    "EOS-IN-UE": {
      title: "インストールに失敗しました",
      description: "問題が生じました。サポートに連絡してください。",
    },
    "EOS-IN-FF": {
      title: "インストールに失敗しました",
      description:
        "Epic Online Services に接続できませんでした。サポートに連絡してください。",
    },
    "EOS-IN-FF-*": {
      title: "インストールに失敗しました",
      description:
        "Epic Online Services へのリクエストを実行できませんでした。サポートに連絡してください。",
    },
    fallback: {
      title: "問題が生じました！",
      description: "問題が生じました。サポートに連絡してください。",
    },
  },
};
